import { render, staticRenderFns } from "./StripeDesign.vue?vue&type=template&id=2e862c4f&scoped=true&"
import script from "./StripeDesign.vue?vue&type=script&lang=js&"
export * from "./StripeDesign.vue?vue&type=script&lang=js&"
import style0 from "./StripeDesign.vue?vue&type=style&index=0&id=2e862c4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e862c4f",
  null
  
)

export default component.exports